import { compose } from 'ramda';
import { connect } from 'react-redux';
import { defaultProps } from 'recompose';

import CommonTable from '@/components/CommonTable';
import {
  updateLimit,
  updatePage,
  updateSort,
} from '@/features/userPage/actions';
import { getLimit, getPage, getSort } from '@/features/userPage/selectors';

import ColGroup from './ColGroup';
import FiltersRow from './FiltersRow';
import HeadRow from './HeadRow';
import Row from './Row';

const mapStateToProps = state => ({
  limit: getLimit(state),
  page: getPage(state),
  sort: getSort(state),
});

const mapDispatchToProps = { updateLimit, updatePage, updateSort };

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  defaultProps({ ColGroup, HeadRow, Row, TopRow: FiltersRow }),
)(CommonTable);
